var _path, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDe = function SvgDe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5338_5994)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5338_5994",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 513,
    height: 512
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.5 0H0.5V512H512.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5338_5994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 341.3H512.5V512H0.5V341.3Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H512.5V170.7H0.5V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 170.7H512.5V341.3H0.5V170.7Z",
    fill: "#DD0000"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 513,
    height: 512,
    fill: "#CFCFCF",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5338_5994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 512,
    fill: "white"
  })))));
};
export default SvgDe;